<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <data-table
            v-model="table"
            :get-page="getPage"
            :per-page="250"
            :selectable-rows="true"
          >
            <template #head(company)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.company"
                input-type="number"
              />
            </template>
            <template #head(articleId)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.articleId"
              />
            </template>
            <template #head(imageRanking)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.imageRanking"
                input-type="number"
              />
            </template>
            <template #head(imageNumber)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.imageNumber"
                input-type="number"
              />
            </template>
            <template #head(displayImagePath)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.displayImagePath"
              />
            </template>
            <template #head(dataHash)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.dataHash"
              />
            </template>
            <template #head(primaryKey)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.primaryKey"
              />
            </template>
            <template #head(articlePositionInPicture)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.articlePositionInPicture"
                input-type="number"
              />
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../../table/data-table';
import { NotificationMixin, ArticleMixin } from '../../../mixins';
import TableFilter from '../../table/table-filter';
import PageHeader from '../../structure/page-header';

export default {
  name: 'ArticleKeywords',
  components: { PageHeader, DataTable, TableFilter },
  mixins: [NotificationMixin, ArticleMixin],
  data: function() {
    return {
      table: {
        selectedRow: null,
        rows: [],
        fields: [
          { key: 'company', label: this.$translate('company') },
          { key: 'articleId', label: this.$translate('article') },
          { key: 'imageRanking', label: this.$translate('image_ranking') },
          { key: 'imageNumber', label: this.$translate('image_number') },
          {
            key: 'displayImagePath',
            label: this.$translate('display_image_path'),
          },
          { key: 'dataHash', label: this.$translate('data_hash') },
          { key: 'primaryKey', label: this.$translate('primary_key') },
          {
            key: 'articlePositionInPicture',
            label: this.$translate('article_position_in_picture'),
          },
        ],
        filter: {
          company: null,
          articleId: null,
          imageRanking: null,
          imageNumber: null,
          displayImagePath: null,
          dataHash: null,
          primaryKey: null,
          articlePositionInPicture: null,
        },
      },
    };
  },
  methods: {
    async getPage(ctx) {
      try {
        const response = await this.articleService.getArticlePictures(ctx);
        return { totalCount: response.totalCount, data: response.data };
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>
